<template>
  <span
    class="w-[18px] h-[18px] rounded-[4px] border flex items-center justify-center shrink-0"
    :class="
      checked ? 'bg-[#2ABB7F] border-[#2ABB7F]' : 'bg-white border-[#D1D5DB]'
    "
  >
    <svg
      v-if="checked"
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3L3 4.8L7 1"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
